module.exports = __webpack_public_path__ + "static/media/mosk_extra-bold_800-webfont.b25e469f.woff2";